module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319067.74c5b628.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319067.pdf
// module id = 833
// module chunks = 0